export default __webpack_public_path__ + "static/media/2.a55a5571.jpg";